<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        color="primary"
        @click="dialog = true"
        ><v-icon left>mdi-upload</v-icon>Upload File(s)</v-btn
      >
    </template>

    <v-card class="primary--text" v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title> Upload File(s) </v-card-title>
        <v-card-text @drop.prevent="addDropFile" @dragover.prevent class="pt-0">
          <validation-provider
            ref="fileInputRef"
            :rules="{ required: true }"
            v-slot="{ errors }"
          >
            <v-file-input
              v-model="selectedFiles"
              prepend-icon="mdi-paperclip"
              label="Select File(s)"
              counter
              multiple
              chips
              truncate-length="6"
              single-line
              :error-messages="errors"
            ></v-file-input>
          </validation-provider>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-select
              v-model="aarLocation"
              prepend-icon="mdi-map-marker"
              label="AAR Location"
              :items="aarLocations"
              :error-messages="errors"
              class="mb-5"
            ></v-select>
          </validation-provider>
          <date-picker
            :field="{ label: 'Date of Service' }"
            :value="dateOfService"
            :validations="{ required: true }"
            @fieldChange="dateOfService = $event"
          >
          </date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            :disabled="loading || invalid"
            text
            @click.once="upload"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      selectedFiles: [],
      dateOfService: null,
      aarLocation: null,
      loading: false,
    };
  },
  computed: {
    aarLocations: function () {
      return this.$store.state.optionsModule.aarLocations;
    },
  },
  methods: {
    addDropFile(e) {
      this.selectedFiles.push(...Array.from(e.dataTransfer.files));
      this.$refs.fileInputRef.validate();
    },
    async upload() {
      this.loading = true;
      this.$emit(
        "uploadAssessments",
        this.dateOfService,
        this.aarLocation,
        this.selectedFiles,
        async () => {
          this.clear();
        }
      );
      this.loading = false;
    },
    clear() {
      this.$refs.form.reset();
      this.selectedFiles = [];
      this.dateOfService = null;
      this.aarLocation = null;
      this.dialog = false;
    },
  },
};
</script>
